var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.add
        ? _c("swb-query-sort-area", {
            attrs: { config: _vm.queryConfig, queryHandler: _vm.queryHandler }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }, [
        _vm.add
          ? _c(
              "a",
              {
                staticClass: "swb-btn-link fr mt5",
                on: { click: _vm.selectAllServicer }
              },
              [_vm._v("设置默认服务商")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.servcTypeList, function(servcType, index) {
          return _c("el-card", { staticClass: "box-card mt10" }, [
            _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header"
              },
              [
                _c("span", { staticClass: " font18 font-gold" }, [
                  _vm._v(_vm._s(servcType.text))
                ]),
                _vm._v(" "),
                _vm.add
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { float: "right", padding: "3px 0" },
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            _vm.selectServicer(servcType.value, servcType.text)
                          }
                        }
                      },
                      [_c("span", [_vm._v("选择服务商")])]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text item" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.comnRepairServicerMap[servcType.value],
                      border: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "servicerName", label: "服务商" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "是否默认" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.defaulted
                                ? _c("span", { staticClass: "font-red" }, [
                                    _vm._v("是")
                                  ])
                                : _c("span", [_vm._v("否")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    !_vm.showServc
                      ? _c("el-table-column", {
                          attrs: { prop: "servcTitle", label: "服务" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "memo", label: "备注" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _vm.add
                                ? _c("el-input", {
                                    attrs: { placeholder: "请输入备注" },
                                    model: {
                                      value: rows.row.memo,
                                      callback: function($$v) {
                                        _vm.$set(rows.row, "memo", $$v)
                                      },
                                      expression: "rows.row.memo"
                                    }
                                  })
                                : _c("span", [_vm._v(_vm._s(rows.row.memo))])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.add
                      ? _c("el-table-column", {
                          attrs: { label: "操作" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  !rows.row.defaulted
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.setDefaulted(
                                                rows.row.servicerId,
                                                servcType.value
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("设置默认")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rows.row.ssuId == null
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.setServc(
                                                rows.row.servicerId,
                                                servcType.value
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("设置服务")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rows.row.ssuId != null
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.deleteServc(
                                                rows.row.servicerId,
                                                servcType.value
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("删除服务")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteServicer(
                                            rows.row.servicerId,
                                            servcType.value
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e10e40e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e10e40e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shopComnReq/ShopComnRepairServicerList.vue
// module id = 2370
// module chunks = 0